let handler

const subscribe = (_handler) => handler = _handler

const addNotification = (tplName, props) => {
  if (typeof handler === 'function') {
    handler(tplName, props)
  }
}


export default {
  subscribe,
  addNotification,
}
